import tw, { styled } from 'twin.macro';

export const VideoContainer = styled.div`
  ${tw`relative`}
  ${tw`pb-[56.25%]`}
`;

export const VideoIFrame = styled.iframe`
  ${tw`absolute`}
  ${tw`top-0 left-0`}
  ${tw`w-full h-full`}
`;
